module.exports = __webpack_public_path__ + "static/media/regimen-female.c14ee4c6.svg";